import React, { useState, useEffect, useRef } from "react";
import { Box, Card, Chip, Typography } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Grid from "@mui/material/Grid";
import { ImageUploadWithPreviewProps } from "../../services/types";
import "./Upload.css";
import CommonPopup from "../Popup/Popup";
import { useLocation } from "react-router-dom";
import { createInfluencer, influncerSelectedImagesVariation } from "../../services/apiService"
import { useAIInfluencerVariationWebSocket } from "../../context/AIInfluencerVariationProvider";
import { showToast } from "../Toast/CommonToast";
import './Upload.css'
import UploadImageCard from '../Reusable/UploadImageCard';
// import { AspectRatio } from "@mui/icons-material";
import LoaderWithBackdrop from "../Loader/loader";
import { useCreditPoints } from "../../services/CreditPointsProvider";
import GridOnIcon from '@mui/icons-material/GridOn';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import Masonry from "react-masonry-css";
import {getModel} from "../../services/apiService";




const ImageUploadWithPreview: React.FC<ImageUploadWithPreviewProps> = ({
  handleFileUpload,
  images,
  setImages,
  modelId
}) => {
    const [popupOpen, setPopupOpen] = useState(false);
  // const location = window.location.href;  
  const locationState = useLocation();
  const modelType = locationState.state?.modelType;
  const createAIinfluncerDetails = locationState.state?.createAIinfluncer;

  const [variationSelection, setVariationSelection] = useState<any[]>([]); // Initialize with dummy data or empty array
  const { reconnectWebSocket, arrayofResponseData } = useAIInfluencerVariationWebSocket()
  const [isLoading, setIsLoading] = useState(false);
  const [shouldOpenPopup, setShouldOpenPopup] = useState(false);
  const { fetchCreditPoints } = useCreditPoints();
  const [viewType, setViewType] = useState<'grid' | 'masonry'>('grid');
  const [originalModel, setOriginalModel] = useState<any>(null);


  useEffect(()=>{
    const fetchOriginalModel = async () => {
      if (modelId) {
        const data = await getModel(modelId);
        setOriginalModel(data);
      }
    };
    fetchOriginalModel();
  }, [modelId]);

  // Instead, use a useEffect to push new images only if not already present
  console.log('mycreateAIinfluncerDetails', createAIinfluncerDetails, images);
  // useEffect(() => {
  //   if (createAIinfluncerDetails && setImages) {
  //     setImages((prev: any[] = []) => {
  //       // Merge previous and new items
  //       const detailsArr = Array.isArray(createAIinfluncerDetails) ? createAIinfluncerDetails : [createAIinfluncerDetails];
  //       const merged = [...prev, ...detailsArr];
  //       // Deduplicate by _id
  //       const dedupedMap = new Map();
  //       merged.forEach((img: any) => {
  //         if (img && img._id) dedupedMap.set(img._id, img);
  //       });
  //       return Array.from(dedupedMap.values());
  //     });
  //   }
  // }, [createAIinfluncerDetails]);


  const eventId = localStorage.getItem("aiVariationID") || "6834224e227c23ad8919e8bd"

  // variation Selction Imges list
useEffect(() => {
  if (arrayofResponseData && Array.isArray(arrayofResponseData) && arrayofResponseData.length > 0) {
     setVariationSelection(arrayofResponseData || []);
  }
}, [arrayofResponseData]);



  // ? images.filter((image:any) => image.type === selectedType)
  // : images;
  // generate Variation function
  const userId = localStorage.getItem("userId") || "";

  console.log("variationSelection", variationSelection)

  console.log('testing images', images);
  console.log('arrayofResponseData', arrayofResponseData);


  const handleGenerateVariation = async () => {
    // setPopupOpen(true);
    // return;
    reconnectWebSocket(eventId);
    setIsLoading(true);
    const details = Array.isArray(createAIinfluncerDetails) ? createAIinfluncerDetails[0] : createAIinfluncerDetails;
    try {
      const model: any = {
        userId: userId || '',
        eventId: eventId,
        prompt: details?.enhancedPrompt || originalModel?.data?.caption || details?.prompt || originalModel?.data?.prompt || "",
        referenceImageId: originalModel?.data?.referenceImageId || details?._id || "",
        imageUrl: details?.url || originalModel?.data?.url || details?.referenceImageUrl || "",
        AspectRatio: '1:1',
        modelId: details?.userModelId || originalModel?.data?._id || createAIinfluncerDetails?._id || "",
        aspectRatio: '1:1',
        // creditsPoints: 25,
      };
      const response = await createInfluencer(model);
      setIsLoading(false);
      if (response.status === "success") {
        setVariationSelection(response.data?.imageGenerationId?.data || []);
        setPopupOpen(true);
        setShouldOpenPopup(true);
      } else {
        showToast(response.message || "Failed to generate variation", "error");
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(error.message || "An error occurred while generating variation", "error");
    }
  }


  const handleProceed = async (selectedIds?: string[]) => {
    setIsLoading(true);
    try {
      const payLoad = {
        userId: userId || '',
        eventId: eventId,
        imageIds: selectedIds,
        modelId: images[0]?.modelId ,
      };
      console.log("payLoad", payLoad,images[0]?.modelId);
      const response = await influncerSelectedImagesVariation(payLoad);
      setIsLoading(false);
      console.log("response", response);
      if (response.status === "success") {
        setVariationSelection(response?.data || []);
        setImages?.((prev: any[] = []) => {
          const existingIds = new Set(prev.map(img => img._id));
          const newItems = (response?.data || []).filter((img: any) => !existingIds.has(img._id));
          return [...newItems, ...prev];
        });
        setPopupOpen(false);
        fetchCreditPoints(userId);
        setShouldOpenPopup(false);
        showToast(response.message, "success");
      } else {
        showToast(response.message || "Failed to proceed", "error");
      }
    } catch (error: any) {
      setIsLoading(false);
      showToast(error.message || "An error occurred while proceeding", "error");
    }
  }
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleUploadClick = () => {
    if (fileInputRef.current ) fileInputRef.current.click();
  };


  // Open popup only after variationSelection contains
  useEffect(() => {
    if (shouldOpenPopup && variationSelection && Array.isArray(variationSelection) && variationSelection.length ) {
      setPopupOpen(true);
      setShouldOpenPopup(false);
    }
  }, [variationSelection, shouldOpenPopup]);


  

  return (
    <>
      <Box
        sx={{
          display: "block",
          gap: 1.5,
          padding: 2,
          borderRadius: "8px",
          width: "100%",
          flexWrap: "wrap",
          overflowY: "auto",
          height: modelType === "AiInfluencer" || modelType === "AIInfluencer" ? 'calc(100dvh - 180px)' : "calc(100dvh - 190px)",
        }}
      >
        {isLoading && <LoaderWithBackdrop open={isLoading} />}
        {/* View Toggle Icons aligned right */}
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
          {viewType === "masonry" ?
                        <GridOnIcon className="iconColor" onClick={() => setViewType('grid')} /> :
                        <DynamicFeedIcon className="iconColor" onClick={() => setViewType('masonry')} />
                    }
        </Box>
        {/* Uploaded Images */}
        {viewType === 'grid' ? (
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              style={{ paddingLeft: "16px" }}
              lg={2}
            >
              {(modelType !== "AiInfluencer" && modelType !== "AIInfluencer") ? (
                <>
                  <Grid
                    item
                    style={{ paddingLeft: '16px', height:'300px', width: '100%' }}>
                    <UploadImageCard
                      image={null}
                      onDelete={() => { }}
                      onUploadClick={handleUploadClick}
                      onFileChange={handleFileUpload}
                      fileInputRef={fileInputRef}
                      multiple={true}
                    />
                  </Grid>
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: '300px',
                    width: "100%",
                    cursor: "pointer",
                    border: "2px dashed #aaa",
                    borderRadius: "16px",
                  }}
                  onClick={() => handleGenerateVariation()}
                >
                  <img
                    src={'/assets/EnhanceIcon.svg'}
                    alt="Enhance Icon"
                    className="enhanceIcons"
                  />
                  <Typography variant="body2" className="uploadText">
                    Generate More (100 Credits)
                  </Typography>
                </Box>
              )}
            </Grid>

            {images.length > 0 &&
              images.map((image: any, index: any) => {
                return(
                    <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
                  <Card
                    className="scrollable"
                    sx={{
                      width: "100%",
                      height: 300,
                      backgroundColor: "#2d2d55",
                      borderRadius: "16px",
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                    }}
                  >
                    <img
                      src={image.url}
                      alt={`Uploaded ${index}`}
                      style={{ width: "100%", height: "60%", objectFit: "cover" }}
                    />
                     {image.trainingStatus  && (
                    <Box className="trainingStatus">
                      <Chip
                        label={
                          image.trainingStatus === "completed" ||
                          image.trainingStatus === "Trained" ? "Trained" : image.trainingStatus
                        }
                        className="chipstyle"
                      />
                    </Box>
                  )}
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#ffffff",
                        padding: 1,
                        overflowY: "scroll",
                      }}
                    >
                      {image.caption || image?.prompt || image?.enhancedPrompt || "No caption available"}
                    </Typography>
                  </Card>
                </Grid>
                )
              })}
          </Grid>
        ) : (
          <Masonry 
           breakpointCols={{ default: 5, 1100: 3, 700: 3, 500: 2, 400: 1 }}
                        className="my-masory"
                        columnClassName="my-masonry-grid_column"
                        style={{ width: '100%' }}
          >
            <Box key="upload-card" sx={{ width: '100%', height: modelType === "AiInfluencer" ? 'auto' : "27%" }}>
              {(modelType !== "AiInfluencer" && modelType !== "AIInfluencer") ? (
                <UploadImageCard
                  image={null}
                  onDelete={() => { }}
                  onUploadClick={handleUploadClick}
                  onFileChange={handleFileUpload}
                  fileInputRef={fileInputRef}
                  multiple={true}
                />
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 500,
                    width: "100%",
                    cursor: "pointer",
                    border: "2px dashed #aaa",
                    borderRadius: "16px",
                  }}
                  onClick={() => handleGenerateVariation()}
                >
                  <img
                    src={'/assets/EnhanceIcon.svg'}
                    alt="Enhance Icon"
                    className="enhanceIcons"
                  />
                  <Typography variant="body2" className="uploadText">
                    Generate More (100 Credits)
                  </Typography>
                </Box>
              )}
            </Box>
            {images.length > 0 &&
              images.map((image: any, index: any) => {
                return(
                    <Card
                  key={index}
                  className="scrollable"
                  sx={{
                    width: "100%",
                    height: 500,
                    backgroundColor: "#2d2d55",
                    borderRadius: "16px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  <img
                    src={image.url}
                    alt={`Uploaded ${index}`}
                    style={{ width: "100%", height: "60%", objectFit: "cover" }}
                  />
                  {image.trainingStatus  && (
                    <Box className="trainingStatus">
                      <Chip
                        label={
                         image.trainingStatus === "completed" ||
                          image.trainingStatus === "Trained" ? "Trained" : image.trainingStatus 
                        }
                        className="chipstyle"
                      />
                    </Box>
                  )}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#ffffff",
                      padding: 1,
                      overflowY: "scroll",
                    }}
                  >
                    {image.caption || image?.prompt || image?.enhancedPrompt || "No caption available"}
                  </Typography>
                </Card>
                )
              })}
          </Masonry>
        )}
      </Box>
      {popupOpen && (
        <CommonPopup
          aiInfluencer="AiInfluencer"
          open={popupOpen}
          onClose={() => setPopupOpen(false)}
          createAIinfluncer={variationSelection}
          proccedImages={handleProceed}
          selectionMode={"multiple"}
          onShowMoreImages={handleGenerateVariation}
        />
      )}
    </>
  );
};

export default ImageUploadWithPreview;
